module.exports = __webpack_public_path__ + "img/zpimg.50e032ca.jpg";